export class UserInfo {
  taiKhoan = "";
  matKhau = "";
  email = "";
  soDt = "";
  hoTen = "";
  thongTinDatVe = [];
}


